import { FC } from "react"

import { InputProps, Input } from "ui-kit/components-branded/index"
import { email } from "utils"

export const EmailInput: FC<InputProps> = (props) => (
    <Input
        type="email"
        placeholder="Введите адрес эл. почты"
        name="email"
        required={true}
        title={email.validationErrText}
        pattern={email.validationPattern}
        {...props}
    />
)
